import { Card } from 'react-bootstrap'
import history from 'utils/history'
import { GlobalOutlined } from '@ant-design/icons'

const InfoCard = ({ icon, title, shortDescription }) => (
  <Card className="info-card h-100 border-0 cursor-pointer">
    <Card.Body>
      <div className="icon">
        {icon}
      </div>
      <h4>{title}</h4>
      <p>{shortDescription}</p>
    </Card.Body>
  </Card>
)
export default InfoCard
